/**
 * Copyright 2016 xdot GmbH
 *
 * Author: Carsten Hibbeler
 * Date: 09.02.2016
 *
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import Map from './Map';

import { shallowEqual } from 'plugin/liferay-widgets-react-web';

const Leaflet = L; //this is a hack because we use a global Leaflet

class LocationInput extends React.Component {

    constructor(props) {
        super(props);
        this.mapPlugin = {
            init: this.onMapInit.bind(this)
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        console.log('Update PositionMap', nextProps);

        if (!this.marker) {
            console.log('initMarker', nextProps);
            this.initMarker(nextProps);
        } else {
            const { position, markerOptions } = this.props;
            if (!shallowEqual(markerOptions, nextProps.markerOptions)) {
                console.log('removeLayer', nextProps);
                this.map.removeLayer(this.marker);
                this.initMarker(nextProps);
            } else if (!shallowEqual(position, nextProps.position)) {
                console.log('setLatLng', nextProps);
                this.marker.setLatLng(nextProps.position);
            }
        }
    }

    onMapInit(map) {
        this.map = map;
        map && map.on('click', (e) => this.onPositionChange(e.latlng));
        this.initMarker(this.props);
    }

    onPositionChange(latLng) {
        this.props.onPositionChange(latLng);
    }

    initMarker(props) {
        const { position, defaultPosition } = props,
            p = position || defaultPosition;
        if (p) {
            this.marker = Leaflet.marker(p, {
                ...props.markerOptions,
                draggable: true
            }).addTo(this.map);
            this.map.setView(p, this.props.zoom || 11);
            this.marker && this.marker.on('dragend', () => this.onPositionChange(this.marker.getLatLng()));
        }
    }

    render() {
        const {
            InputElement,
            position,
            nameLatitude = 'latitude',
            nameLongitude = 'longitude',
            plugins = [],
            ...otherProps
        } = this.props;
        const latLng = position && Leaflet.latLng(position);

        return (
            <React.Fragment>
                <Map  { ...otherProps }
                      defaultFallbackMapConfigType={ 'static' }
                      plugins={ plugins.concat(this.mapPlugin) }/>

                {
                    InputElement &&
                    <InputElement name={ nameLatitude } type="hidden" value={ latLng && latLng.lat }/>
                }
                {
                    InputElement &&
                    <InputElement name={ nameLongitude } type="hidden" value={ latLng && latLng.lng }/>
                }

                {
                    !InputElement &&
                    <input name={ nameLatitude } type="hidden" value={ latLng && latLng.lat }/>
                }
                {
                    !InputElement &&
                    <input name={ nameLongitude } type="hidden" value={ latLng && latLng.lng }/>
                }

            </React.Fragment>

        );
    }
}

LocationInput.propTypes = {
    ...Map.propTypes,
    defaultPosition: PropTypes.object,
    markerOptions: PropTypes.object,
    position: PropTypes.object,

    onPositionChange: PropTypes.func.isRequired, //without the input makes no sense

    InputElement: PropTypes.func,

    nameLatitude: PropTypes.string,
    nameLongitude: PropTypes.string,

    center: PropTypes.object,
    zoom: PropTypes.number
};

export default LocationInput;



// WEBPACK FOOTER //
// ./js/components/LocationInput.jsx